export const OAuthCodeFields = () => `
  code
`
export const OAuthTokenFields = () => `
  accessToken,
  refreshToken,
  memberId,
  expiresIn
`
